<template>
  <div class="modalCategories">
    <CategoriesBox />
  </div>
</template>

<script>

import CategoriesBox from '@/components/CategoriesBox.vue'

export default {
  name: 'CategoriesModal',

  data () {
    return {
    }
  },

  components: {CategoriesBox},

  mounted () {
    let parent = this.$parent.$refs['products']
    // let left = parent.offsetLeft
    let top = parent.offsetTop
    this.$el.style.top = top + 100 + 'px'
    //this.$el.style.left = left + 'px'
    // console.log(this.$el, parent, top, left)
  },

  destroyed () {
    console.log('categories destroy')
  },
}
</script>

<style lang="scss">
@import "@/css/_variables.scss";

.modalCategories {
  z-index:10000;
  position:absolute;
  width:1009px;
  left:calc(50vw - 512px);
  border:0px;
  background-color: #CCC9C5;
  padding:15px;
  text-align:center;
  margin:0px;
}

</style>
